<template>
  <div>
      <!-- 云校 -->
      <yx-growup-preview v-if="productCode == 1" />
      <!-- 成长粒 -->
      <czl-growup-preview v-if="productCode == 16" />
  </div>
</template>

<script>
  import yxGrowupPreview from './components/yx-growup-preview.vue';
  import czlGrowupPreview from './components/czl-growup-preview.vue';

  export default {
    data() {
      return {
        pageTitle: "成长记录详情",
        productCode: '1'
      }
    },
    components: {
      yxGrowupPreview,
      czlGrowupPreview
    },
    created() {
      this.productCode = this.$route.query.productCode || '1';
    }
  }
</script>